import React, { useRef, useEffect } from 'react';
import { getCanva } from 'services/chart';
import { Niveau } from '../../../../types/note/niveau.def';

export interface GraphRadarValue {
  type: string;
  niveau: Niveau;
  emoji: string;
}

export interface GraphRadarProps {
  values: GraphRadarValue[];
}

export const GraphRadar = ({ values }: GraphRadarProps) => {
  const ref = useRef(null);

  useEffect(() => {
    const chart = getCanva(values, ref.current.getContext('2d'));
    return () => chart.destroy();
  }, [values]);

  return <canvas ref={ref} />;
};
